import { expenseTypeDescriptions } from '@/helpers/const';

const erhlDescriptionOverrides: Record<string, Record<string, string>> = {
  private_health_insurance: {
    shortFormTitle: 'Private health insurance',
    tooltip: 'Private health insurance.',
  },
  personal_insurance: {
    shortFormTitle: 'Other personal insurances',
    tooltip: 'Life, personal and other insurances.',
  },
};

export function getErhlExpenseDescription(type: string): Record<string, string> {
  return erhlDescriptionOverrides[type] ?? expenseTypeDescriptions[type] ?? { shortFormTitle: '', tooltip: '' };
}
